import React, { ReactNode } from 'react'
import { StyleWrapper } from './style'

const Wrapper = ({ children }: { children: ReactNode }) => {
  return <StyleWrapper>{children}</StyleWrapper>
}

export default Wrapper
